export const ADMIN_ACCESS = ['AppSupportAdmin', 'AppAdmin'];
export const NON_ADMIN_ACCESS = ['AppLead', 'AppUser'];
export const COMPLETE_ACCESS = ['AppSupportAdmin', 'AppAdmin', 'AppLead', 'AppUser'];






